// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.geosuggest__suggests {
  background: white;
  list-style-type: none;
  padding-left: 0.5rem;
}

li.geosuggest__item {
  list-style-type: none;
}

.geosuggest__item--active {
  background: #b4b4b4;
  color: #fff;
}

.geosuggest-item {
  font-size: 1.3rem;
  cursor: pointer;
}

.geosuggest__suggests--hidden {
  display: none;
}

.geosuggest {
  font-size: 1.4rem;
  margin: 0;
}
.geosuggest__item {
  font-size: 1.4rem;
}
.geosuggest__input {
  padding: 0 0.5rem;
}
.geosuggest__input-wrapper {
  height: 2.9rem;
}
.geosuggest__suggests {
  border: 0.1rem solid #696969;
  border-top: 0;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Global/Form/GeoSuggest.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AACA;EACE,iBAAA;EACA,qBAAA;EACA,oBAAA;AAEF;;AACA;EACE,qBAAA;AAEF;;AAAA;EACE,mBAAA;EACA,WAAA;AAGF;;AAAA;EACE,iBAAA;EACA,eAAA;AAGF;;AAAA;EACE,aAAA;AAGF;;AAAA;EACE,iBAAA;EACA,SAAA;AAGF;AADE;EACE,iBAAA;AAGJ;AAAE;EACE,iBAAA;AAEJ;AACE;EACE,cAAA;AACJ;AAEE;EACE,4BAAA;EACA,aAAA;AAAJ","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n@import '~/Styles/Variables';\n\n.geosuggest__suggests {\n  background: white;\n  list-style-type: none;\n  padding-left: 0.5rem;\n}\n\nli.geosuggest__item {\n  list-style-type: none;\n}\n.geosuggest__item--active {\n  background: #b4b4b4;\n  color: #fff;\n}\n\n.geosuggest-item {\n  font-size: 1.3rem;\n  cursor: pointer;\n}\n\n.geosuggest__suggests--hidden {\n  display: none;\n}\n\n.geosuggest {\n  font-size: 1.4rem;\n  margin: 0;\n\n  &__item {\n    font-size: 1.4rem;\n  }\n\n  &__input {\n    padding: 0 0.5rem;\n  }\n\n  &__input-wrapper {\n    height: 2.9rem;\n  }\n\n  &__suggests {\n    border: 0.1rem solid $darkTextColor;\n    border-top: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
